module.exports.title = 'Book Reviews: ${title} by ${author}'
module.exports.description = 'Book Reviews: ${title} by ${author}'
module.exports.short_title = 'Book Reviews: ${title}'
module.exports.short_description = 'Book Reviews: ${title}'